import { render, staticRenderFns } from "./SlideListBirthday.vue?vue&type=template&id=542a0bc7&"
import script from "./SlideListBirthday.vue?vue&type=script&lang=js&"
export * from "./SlideListBirthday.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports